const MINIMUM_SEARCH_LENGTH = 2;
const SEARCH_DELAY = 250;

function buildSearchUrl(template, term) {
    return template.replace(
        '__TERM__',
        encodeURIComponent(term)
    );
}

function hideResults(form, results) {
    results.hidden = true;
    results.innerHTML = '';

    const input = form.querySelector('input[type="search"], [name="q"]');
    input?.setAttribute('aria-expanded', 'false');
}

function showResults(form, results, html) {
    results.innerHTML = html;
    results.hidden = false;

    const input = form.querySelector('input[type="search"], [name="q"]');
    input?.setAttribute('aria-expanded', 'true');
}

async function loadResults(form, results, term, controller) {
    const endpoint = form.dataset.searchEndpoint;

    if (!endpoint) {
        return;
    }

    results.hidden = false;
    results.innerHTML = `
        <div class="v2-search-results__status">
            <span
                class="spinner-border spinner-border-sm"
                aria-hidden="true"
            ></span>
            Zoeken…
        </div>
    `;

    try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('term', term);

        const response = await fetch(url.toString(), {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'text/html',
                'X-Requested-With': 'XMLHttpRequest',
            },
            signal: controller.signal,
        });

        if (!response.ok) {
            throw new Error('Zoeken mislukt.');
        }

        const html = await response.text();

        if (!html.trim()) {
            showResults(
                form,
                results,
                '<div class="v2-search-results__status">Geen resultaten gevonden.</div>'
            );
            return;
        }

        showResults(form, results, html);
    } catch (error) {
        if (error.name === 'AbortError') {
            return;
        }

        showResults(
            form,
            results,
            '<div class="v2-search-results__status is-error">Zoeken is momenteel niet beschikbaar.</div>'
        );
    }
}

function initialiseSearchForm(form) {
    const input = form.querySelector('input[type="search"], [name="q"]');
    const results = form.parentElement?.querySelector(
        '[data-header-search-results]'
    );

    if (!input || !results) {
        return;
    }

    let timer = null;
    let requestController = null;

    input.addEventListener('input', () => {
        const term = input.value.trim();

        window.clearTimeout(timer);
        requestController?.abort();

        if (term.length < MINIMUM_SEARCH_LENGTH) {
            hideResults(form, results);
            return;
        }

        timer = window.setTimeout(() => {
            requestController = new AbortController();

            loadResults(
                form,
                results,
                term,
                requestController
            );
        }, SEARCH_DELAY);
    });

    input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            hideResults(form, results);
            input.blur();
        }
    });

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const term = input.value.trim();
        const template = form.dataset.searchUrlTemplate || '';

        if (!term) {
            hideResults(form, results);
            input.focus();
            return;
        }

        if (!template.includes('__TERM__')) {
            return;
        }

        window.location.assign(
            buildSearchUrl(template, term)
        );
    });

    document.addEventListener('click', (event) => {
        if (!form.parentElement?.contains(event.target)) {
            hideResults(form, results);
        }
    });
}

export function initialiseHeaderSearch() {
    document
        .querySelectorAll('[data-header-search]')
        .forEach(initialiseSearchForm);
}
